import { createAsyncThunk } from '@reduxjs/toolkit';
import { courseApi } from '~/apis/course';
import {
  GET_COURSE_MATERIALS,
  GET_COURSES_DETAIL_OF_STUDENT,
  GET_COURSES_OF_STUDENT,
  GET_DETAIL_COURSES,
  GET_DISCUSSION_OF_COURSE,
  GET_LIST_COURSES,
  GET_LIST_UPCOMING_COURSES,
  GET_MODULE_OF_COURSE,
  UPDATE_COURSES,
} from '~/utils/constants/actionType';
import {
  IPayloadGetCoursesDetailOfStudent,
  IPayloadGetDiscussionsOfCourse,
  IPayloadGetModulesOfCourse,
  IPayloadUpdateCourses,
  IQueryGetCourses,
  IQueryGetCoursesOfStudent,
} from '~/utils/interface/course';

export const getCourses = createAsyncThunk(GET_LIST_COURSES, async (query: IQueryGetCourses, { rejectWithValue }) => {
  try {
    const res = await courseApi.getCourses(query);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateCourses = createAsyncThunk(
  UPDATE_COURSES,
  async (payload: IPayloadUpdateCourses, { rejectWithValue }) => {
    try {
      const res = await courseApi.updateCourses(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCourseUpcoming = createAsyncThunk(GET_LIST_UPCOMING_COURSES, async (_, { rejectWithValue }) => {
  try {
    const res = await courseApi.getCourseUpcoming();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailCourse = createAsyncThunk(
  GET_DETAIL_COURSES,
  async (payload: { coursesId: string; lessonId: string }, { rejectWithValue }) => {
    try {
      const res = await courseApi.getDetailCourse(payload.coursesId, payload.lessonId);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCoursesOfStudent = createAsyncThunk(
  GET_COURSES_OF_STUDENT,
  async (payload: IQueryGetCoursesOfStudent, { rejectWithValue }) => {
    try {
      const res = await courseApi.getCoursesOfStudent(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getModulesOfCourse = createAsyncThunk(
  GET_MODULE_OF_COURSE,
  async (payload: IPayloadGetModulesOfCourse, { rejectWithValue }) => {
    try {
      const res = await courseApi.getModulesOfCourse(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCourseMaterials = createAsyncThunk(GET_COURSE_MATERIALS, async (_, { rejectWithValue }) => {
  try {
    const res = await courseApi.getCourseMaterials();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDiscussionsOfCourse = createAsyncThunk(
  GET_DISCUSSION_OF_COURSE,
  async (payload: IPayloadGetDiscussionsOfCourse, { rejectWithValue }) => {
    try {
      const res = await courseApi.getDiscussionsOfCourse(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCoursesDetailOfStudent = createAsyncThunk(
  GET_COURSES_DETAIL_OF_STUDENT,
  async (payload: IPayloadGetCoursesDetailOfStudent, { rejectWithValue }) => {
    try {
      const res = await courseApi.getCoursesDetailOfStudent(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
